//#region Context Symbols
export const STDIN_CTX = Symbol('wolfie:stdin')
export const STDOUT_CTX = Symbol('wolfie:stdout')
export const STDERR_CTX = Symbol('wolfie:stderr')
export const APP_CTX = Symbol('wolfie:app')
export const FOCUS_CTX = Symbol('wolfie:focus')
export const ACCESSIBILITY_CTX = Symbol('wolfie:accessibility')
export const BACKGROUND_CTX = Symbol('wolfie:background')
export const THEME_CTX = Symbol('wolfie:theme')

//#region List Context Symbols
export const UL_DEPTH_CTX = Symbol('wolfie:ul-depth')
export const UL_MARKER_CTX = Symbol('wolfie:ul-marker')
export const OL_COUNTER_CTX = Symbol('wolfie:ol-counter')
//#endregion List Context Symbols
//#endregion Context Symbols
